export default __webpack_public_path__ + "static/media/2.53d4eb09.jpg";